<div class="barchart-{{data.id}}"></div>
<div class="barchart-1"></div>
